const stringToNumber = (value: string | number) => {
  if (typeof value !== "string") return value;
  return Number(value.replace(/[^0-9-.]+/g, ""));
};

export default stringToNumber;
